// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2n798","range":"MonthRangeSwitch_range__2xMQ8","disabled":"MonthRangeSwitch_disabled__jCbn4"};